var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boxall"},[_vm._m(0),_c('div',{staticClass:"boxnav"},[_c('div',{staticClass:"bg-image"},[_c('div',{staticClass:"qrcode",on:{"click":_vm.openDetail}})])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-head"},[_c('div',{staticClass:"title"},[_vm._v("溯源管理")])])
}]

export { render, staticRenderFns }